import { ref, watch } from "vue";
import { useI18n } from "vue3-i18n";

export const INITIAL_LANG = 'gb';

export const useLanguage = () => {

    const i18n = useI18n();

    const language = ref(localStorage.getItem('language') || INITIAL_LANG);

    watch(language, () => {
        i18n.setLocale(language.value);
    });

    const setLanguage = (lang) => {
        localStorage.setItem('language', lang);
        language.value = lang;
    }

    return { setLanguage, language };
}